var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-back"},[_c('div',{staticClass:"row-back__container",on:{"click":_vm.onClick}},[_c('i',{staticClass:"row-back__icon el-icon-back"}),_c('div',{staticClass:"row-back__text",domProps:{"innerHTML":_vm._s(_vm.text)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }